import { useState } from "react";
import { Abas, Aviso, PainelDaAba } from "../componentes/ui";
import { PainelDeContratos } from "../componentes/horas/PainelDeContratos";
import { PainelDeRegras } from "../componentes/horas/PainelDeRegras";
import { podeNaSessao, useSessao } from "../nucleo/sessao";
import { useTitulo } from "../nucleo/titulo";

type Aba = "contratos" | "regras";

const ABAS = [
  { chave: "contratos", rotulo: "Contratos de horas" },
  { chave: "regras", rotulo: "Regras de aprovação" },
] as const;

/** Horas e aprovação: o que a administração configura para o chamado custar e ser autorizado. */
export function HorasEAprovacoes() {
  useTitulo("Horas e aprovações");
  const sessao = useSessao();
  const [ativa, setAtiva] = useState<Aba>("contratos");

  if (!sessao.data) {
    return (
      <p className="lead" role="status">
        Verificando o seu acesso…
      </p>
    );
  }
  const contratos = podeNaSessao(sessao.data, "horas:gerenciar");
  const regras = podeNaSessao(sessao.data, "aprovacao:gerenciar");
  if (!contratos && !regras) {
    return (
      <Aviso tom="marca" data-testid="horas-sem-permissao">
        Contratos de horas e regras de aprovação são mantidos pela administração do portal.
      </Aviso>
    );
  }
  const abas = ABAS.filter((aba) => (aba.chave === "contratos" ? contratos : regras));
  const aba: Aba = abas.some((item) => item.chave === ativa) ? ativa : (abas[0]?.chave ?? "contratos");

  return (
    <div data-testid="horas-e-aprovacoes">
      <h1 className="titulo-pagina">Horas e aprovações</h1>
      <p className="lead mb-4">
        Contratos de horas por empresa, com saldo e extrato, e as regras que exigem aprovação antes de um chamado seguir.
      </p>
      <Abas rotulo="Horas e aprovações" id="horas" itens={abas} ativa={aba} aoSelecionar={setAtiva} className="mb-4" />
      {contratos ? (
        <PainelDaAba id="horas" chave="contratos" ativa={aba} data-testid="painel-contratos">
          <PainelDeContratos />
        </PainelDaAba>
      ) : null}
      {regras ? (
        <PainelDaAba id="horas" chave="regras" ativa={aba} data-testid="painel-regras">
          <PainelDeRegras />
        </PainelDaAba>
      ) : null}
    </div>
  );
}
